import React from 'react';
import './AboutUs.css';

function AboutUs() {
    return (
        <section id="about" className="about-section">
            <div className="about-container">
                <div className="about-text">
                    <h2>Our Mission</h2>
                    <p>
                        At RapidPhysio, we empower world to heal through accessible, compassionate and personalized care—delivered at home or virtually and make rehabilitation accessible, compassionate and tailored to each person’s journey .Our goal is to restore health, mobility, and vitality, redefining wellness with cutting-edge therapy solutions that meet you where you are.  Because everyone deserves the freedom to live life fully
                    </p>
                    <h2>Our Vision</h2>
                    <p>
                        To revolutionize rehabilitation in India by becoming the nation’s most trusted provider of home visit and telehealth physiotherapy, bridging the gap between clinical excellence and everyday convenience.
                    </p>
                </div>
                <div className="about-image">
                    <img
                        src="https://physiotherapistahmedabad.com/wp-content/uploads/2021/10/Chiropractor1-600x400.png"
                        alt="Physio Treatment"
                    />
                </div>
            </div>
        </section>
    );
}

export default AboutUs;
